import definedAbility from "@/ability";
const ability = definedAbility();

export default [
  {
    name: "authors",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "page_categories",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "domains",
    label: "url",
    routes: ["list", "create", "show"],
  },
  {
    name: "pages",
    label: "headline",
    routes: ["list", "edit", "create"],
  },
  {
    name: "users",
    label: "email",
    routes: ["list", "edit", "create"],
  },
  {
    name: "headers",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "footers",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "sidebars",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "modals",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "favorites_blocks",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "organizations",
    label: "name",
    routes: [],
  },
  {
    name: "menus",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "ab_tests",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  {
    name: "labels",
    label: "label",
    routes: [],
  },
  ability.can("view", "page tests") && {
    name: "page_tests",
    label: "name",
    routes: ["list"],
  },
  ability.can("view", "phone numbers") && {
    name: "phone_numbers",
    label: "name",
    routes: ["list", "show", "create"],
  },
  ability.can("view", "form setup") && {
    name: "external_forms",
    label: "name",
    routes: ["list"],
  },
  ability.can("view", "calendars") && {
    name: "calendars",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  ability.can("view", "global alternative content") && {
    name: "alternative_contents",
    label: "name",
    routes: ["list", "edit", "create"],
  },
  ability.can("view", "login to airbyte") && {
    name: "airbyte_sources",
    label: "name",
    routes: ["list"],
  },
].filter(Boolean);
